// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaConnectionRect } from '../../interfaces/dna-syngovia-connection-rect';
import { DnaSyngoviaGroupNodeEType } from '../../interfaces/dna-syngovia-group-node';
import { AbstractChartMapService } from './abstract-chart-map.service';

@Injectable({
  providedIn: 'root',
})
export class ServerChartMapService extends AbstractChartMapService {
  public override calculateRectValues(
    rects: DnaSyngoviaConnectionRect[],
    row: number,
    column: number,
    height: number,
  ): { row: number; column: number } | void {
    rects.forEach((rect) => {
      const type = rect.connection.groupNode.type;
      const x =
        this.NUM_OF_COLUMNS *
        this.getWidthPadding(DnaSyngoviaGroupNodeEType.MODALITY);
      const y = 0;

      rect.rect = this.createDOMRectInstance(x, y, type, height);
    });
  }

  protected override calculateLinePath(): string | null {
    return null;
  }
}
